import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled, { css } from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import PropTypes from 'prop-types';
import { colors } from '@vds-core/theme';
var propTypes = {
  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * @ignore
   */
  height: PropTypes.number,

  /**
   * @ignore
   */
  width: PropTypes.number,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  error: PropTypes.bool,

  /**
   * @ignore
   * If provided, an object containing color values in hex will be returned
   */
  colorConfig: PropTypes.object,
  //Deprecated
  checked: PropTypes.bool
};
var defaultProps = {
  disabled: false,
  error: false,
  height: 20,
  width: 20,
  colorConfig: colors //Deprecated
  //error: false

};

var getValidationState = function getValidationState(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      colorConfig = _ref.colorConfig;

  if (disabled) {
    return colorConfig.coolGray3;
  }

  if (error) {
    return colorConfig.error;
  }

  return null;
};

var StyledRadioSVG = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StyledRadioSVG",
  componentId: "wup6j7-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  left: ", ";\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: ", ";\n  margin: 0;\n  fill: ", ";\n  .cls-circle {\n    fill: ", ";\n  }\n"])), calculateRem(20), calculateRem(-20), calculateRem(20), function (props) {
  return getValidationState(props);
}, function (props) {
  return props.disabled ? props.colorConfig.coolGray3 : props.colorConfig.black;
});
/**
 * @ignore
 */

var RadioButtonIcon = function RadioButtonIcon(props) {
  var selected = props.checked || props.selected || false;
  return /*#__PURE__*/React.createElement(StyledRadioSVG, _extends({}, props, {
    viewBox: "0 0 20 20",
    height: props.height,
    width: props.width,
    focusable: "false",
    "aria-hidden": true,
    colorConfig: props.colorConfig
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,1a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-1A10,10,0,1,0,20,10,10,10,0,0,0,10,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-circle"
  }, selected && /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "4"
  })));
};

RadioButtonIcon.defaultProps = defaultProps;
RadioButtonIcon.propTypes = propTypes;
export default RadioButtonIcon;